import { AlertTriangle, X } from "lucide-react";

export function ConfirmDialog({ open, title, description, confirmLabel, tone = "default", busy, onConfirm, onClose }: {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  tone?: "default" | "danger";
  busy?: boolean;
  onConfirm(): void;
  onClose(): void;
}) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="modal confirm-modal" role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-description">
        <header className="modal-header"><span className={"dialog-icon " + tone}><AlertTriangle size={22} /></span><button className="icon-button" onClick={onClose} aria-label="关闭"><X size={19} /></button></header>
        <h2 id="confirm-title">{title}</h2>
        <p id="confirm-description" className="modal-copy">{description}</p>
        <div className="dialog-actions"><button className="button button-secondary" onClick={onClose} disabled={busy}>取消</button><button className={tone === "danger" ? "button button-danger" : "button button-primary"} onClick={onConfirm} disabled={busy}>{busy ? "处理中…" : confirmLabel}</button></div>
      </section>
    </div>
  );
}
